import { fetchData, HTTP_STATUS } from "dmsbasereact";

const BASE = "/export-jobs";

export const asyncExportApi = {
    /**
     * Enqueue a new async export job.
     * Returns { detail, job_pk } on HTTP 202.
     */
    enqueue: async (jobType, format, filters = [], hiddenColumns = []) => {
        const body = {
            job_type: jobType,
            format,
            filters: filters.map(f => ({ name: f.name, value: f.value })),
            hidden_columns: hiddenColumns,
        };

        const response = await fetchData(`${BASE}/`, "POST", true, body);

        if (response.status === HTTP_STATUS.ACCEPTED_202 || response.status === HTTP_STATUS.OK_200) {
            return response.data;
        }
        const detail = response.data?.detail || "Failed to enqueue export";
        throw new Error(detail);
    },

    /**
     * List current user's last 50 export jobs.
     */
    listMyJobs: async () => {
        const response = await fetchData(`${BASE}/my`, "GET", true);
        if (response.status === HTTP_STATUS.OK_200) {
            return response.data;
        }
        return [];
    },

    /**
     * Dismiss (soft-delete) an export job.
     */
    dismiss: async (pk) => {
        await fetchData(`${BASE}/${pk}`, "DELETE", true);
    },

    /**
     * Return the download URL for a ready job (used with window.location or anchor).
     */
    getDownloadUrl: (pk) => `/${BASE.replace(/^\//, "")}/${pk}/download`,
};
